<template>
    <el-select clearable  @change="handleChange" v-model="data" placeholder="请选择" filterable :disabled="disabled">
      <el-option :label="item.name" :value="item.value" v-for="(item,index) in modle" :key="index" ></el-option>
    </el-select>
</template>

<script>
  import { getCascade } from '@/services/deviceType'

  export default {
    name: 'modle',
    // props: ['brand',"value",'operator'],
    props:{
      brand:{},
      value: {},
      operator: {},
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data(){
      return {data:"",modle:[]}
    },
    mounted(){
      this.loadData();
    },
    watch:{
      brand: {
        immediate: true,
        handler(value) {
          if (value) {
            this.loadData(value);
          } else {
            this.modle = [];
           this.data="";
            this.$emit("input", this.data);
          }
        }
      },
    operator: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadData(value);
        } else {
          this.modle = [];
          // this.data="";
        }
      }
    },
    value: {
      immediate: true,
      handler(value) {

        this.data = value;
      }
    }
    },
    methods:{
      handleChange(value){
        this.$emit("input",value)
        this.$emit("change",value)
        this.data=value;
      },
     async loadData(){

       this.modle=[];
      //  this.data="";
      //  this.$emit("input","")
        if(this.brand && this.operator){
          const response=await getCascade({brand:this.brand,operatorIds:this.operator.value});
          if(response && response.data.modle){
            this.modle=response.data.modle.map((item,i)=>{
              return {name:item.modle,value:item.modle}
            })
            let find=this.modle.find((item,i)=>{return item.name==this.value});
            // console.log(find);
            if(find){
              this.data=this.value;
            }else{
              this.data="";
            }

          }
        }else{
         this.data="";
          this.modle=[];
        }

      }

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/Modle.vue